export const ROOT_URL = require(`./${process.env.NODE_ENV}/application`).ROOT_URL



// WEBPACK FOOTER //
// ./src/constants/application.js